"use strict";

var breakpoints = [40, 52, 64].map(function (n) {
  return "@media screen and (min-width:" + n + "em)";
});

var space = [0, 8, 16, 32, 64];

var typeScale = [64, 48, 32, 24, 16, 14, 12];

var radius = 4;

module.exports = {
  breakpoints: breakpoints,
  space: space,
  typeScale: typeScale,
  radius: radius
};


//////////////////
// WEBPACK FOOTER
// ./~/axs/dist/config.js
// module id = 20
// module chunks = 0